import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class EventRefreshService {
  private refreshRequested$ = new BehaviorSubject<void>(undefined)

  /**
   * Request a refresh of event data
   */
  requestRefresh() {
    this.refreshRequested$.next(undefined)
  }

  /**
   * Get observable for refresh requests
   */
  getRefreshRequests(): Observable<void> {
    return this.refreshRequested$.asObservable()
  }
}
